__turbopack_context__.v({
  "root": "credit-tab-module-scss-module__LAD0MW__root",
});
